"use client"

import { useEffect } from "react"
import { RibbonMenu } from "@/components/editor/ribbon-menu"
import { PdfRibbonToolbar } from "@/components/editor/ribbon/pdf-ribbon-toolbar"
import { useLayoutPanels } from "@/components/editor/dock/layout-context"
import { PANEL_COMPONENTS } from "@/components/editor/dock"
import { setActivePdfTab } from "@/lib/pdf-viewer-state-store"

/**
 * Swaps the Word-style ribbon for the PDF page/zoom/search toolbar while a
 * PDF Preview tab has focus — everywhere else (a code editor tab, Console,
 * an image tab) shows the normal ribbon. Driven by DockableLayout's
 * activePanelComponent (see layout-context.tsx), so it tracks whichever tab
 * last had focus without needing to reach into flexlayout-react itself.
 *
 * Also the one place that tells lib/pdf-viewer-state-store.ts which tab is
 * active — with two PDF Preview tabs open, each keeps its own page/zoom/search
 * state (see synctex-pdf-viewer.tsx), and PdfRibbonToolbar only ever reads
 * whichever one this points at.
 */
export function EditorRibbonBar() {
  const { activePanelComponent, activeTabId } = useLayoutPanels()

  useEffect(() => {
    setActivePdfTab(activeTabId)
  }, [activeTabId])

  if (activePanelComponent === PANEL_COMPONENTS.PDF_PREVIEW) {
    return <PdfRibbonToolbar />
  }
  return <RibbonMenu />
}
